import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import {
  PATH_DASHBOARD_HEADCOUNT,
  PATH_DASHBOARD_NTS,
  PATH_DASHBOARD_NTS_BY_EMPLOYEE,
  PATH_DASHBOARD_PLACEMENT_GOAL,
  PATH_DASHBOARD_PERM_PLACEMENT_GOAL,
  PATH_DASHBOARD_LABOR_EFFICIENCY_RATIO,
  PATH_DASHBOARD_REVENUE_DATA,
  PATH_DASHBOARD_UPCOMING_INTERVIEWS,
  PATH_DASHBOARD_RECRUITERS_PERFORMANCE_DETAILS,
  PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_YEAR,
  PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_MONTH
} from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'

const dashboard = {
  namespaced: true,
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField
  },
  actions: {
    getHeadcount: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_HEADCOUNT })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getNTS: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_NTS })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getNTSByEmployee: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_NTS_BY_EMPLOYEE })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getPlacementGoalCurrentMonth: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_PLACEMENT_GOAL })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getDirectPlacementGoalCurrentMonth: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_PERM_PLACEMENT_GOAL })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getLaborEfficiencyRatioData: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_LABOR_EFFICIENCY_RATIO })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getRevenueData: ({ commit }, year = new Date().getFullYear()) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_REVENUE_DATA, parameters: Object.assign({}, { year: year }) })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getUpcomingInterviews: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_DASHBOARD_UPCOMING_INTERVIEWS })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    },
    getRecruitersPerformanceDetails: ({ commit }, parameters) => {
      commit('updateStatus', { status: IN_PROGRESS })
      return api.doGet({ path: PATH_DASHBOARD_RECRUITERS_PERFORMANCE_DETAILS, parameters: { year: parameters.year } })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          return null
        })
    },
    getGrossProfitDetailsByYear: ({ commit }, parameters) => {
      commit('updateStatus', { status: IN_PROGRESS })
      return api.doGet({ path: PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_YEAR, parameters: { year: parameters.year } })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          return null
        })
    },
    getGrossProfitDetailsByMonth: ({ commit }, parameters) => {
      commit('updateStatus', { status: IN_PROGRESS })
      return api.doGet({ path: PATH_DASHBOARD_GROSS_PROFIT_DETAILS_BY_MONTH, parameters: { year: parameters.year, month: parameters.month } })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          return null
        })
    }
  }
}

export default dashboard
